// extracted by mini-css-extract-plugin
export default {"Container":"playersCard_Container__a98Pe","ImageContainer":"playersCard_ImageContainer__gtsef","Info":"playersCard_Info__s+rVj","Location":"playersCard_Location__zAXn+"};